import Box from "@material-ui/core/esm/Box";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import FormControl from "@material-ui/core/esm/FormControl";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AddressFormSection from 'components/AddressFormSection/AddressFormSection';
import Checkbox from 'components/Form/Checkbox';
import { Info } from 'components/Text';
import AddressTypes from 'constants/addressTypes';
import useStyles from './ChooseAddressStyles';
export default function ChooseAddress({
  defaultAddress,
  currentAddressType,
  setCurrentAddressType
}) {
  const {
    t
  } = useTranslation();
  const {
    chooseAddressRoot,
    radio,
    checked,
    checkboxStyle,
    info
  } = useStyles();
  const {
    control
  } = useFormContext();
  const handleRadioGroupChange = event => {
    const {
      value
    } = event.target;
    setCurrentAddressType(value);
  };
  useEffect(() => {
    if (!defaultAddress) setCurrentAddressType(AddressTypes.SPECIFIC);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: chooseAddressRoot
  }, /*#__PURE__*/React.createElement(FormControl, null, defaultAddress && /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "select address",
    name: "Address",
    value: currentAddressType,
    onChange: handleRadioGroupChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: AddressTypes.CUSTOMER,
    control: /*#__PURE__*/React.createElement(Radio, {
      classes: {
        root: radio,
        checked
      }
    }),
    label: `${defaultAddress?.addressLine1}, ${defaultAddress?.postalCode} ${defaultAddress?.postalDistrict}`
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: AddressTypes.SPECIFIC,
    control: /*#__PURE__*/React.createElement(Radio, {
      classes: {
        root: radio,
        checked
      }
    }),
    label: t('address.another_address')
  }))), (currentAddressType === AddressTypes.SPECIFIC || !defaultAddress) && /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(AddressFormSection, {
    isNewCustomer: false
  }), /*#__PURE__*/React.createElement("div", {
    className: checkboxStyle
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "makeStandard",
    render: ({
      onChange,
      value,
      name
    }) => /*#__PURE__*/React.createElement(Checkbox, {
      name: name,
      setChecked: isChecked => onChange(isChecked),
      checked: value,
      label: t('address.make_standard_delivery_address')
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: info
  }, /*#__PURE__*/React.createElement(Info, null, t('address.standard_delivery_address_info'))))))));
}